// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*.activity-row {
  display: flex;
  justify-content: space-between; /* Ensure space between the boxes */
 /* align-items: flex-start; /* Align items at the top */
 /* gap: 16px; /* Add spacing between the boxes */
  /*flex-wrap: wrap; /* Allow wrapping for responsiveness */
 /* margin: 16px 0; /* Add some spacing around the row */
/*} */

/* .AP_ModuleProjectLesson {
  /*flex: 1 1 calc(50% - 16px); /* Take 50% of the container minus the gap */
  /*box-sizing: border-box; /* Include padding and borders in width calculation */
  /*max-width: calc(50% - 16px); /* Prevent exceeding 50% width */
  /*min-width: 350px; /* Set a minimum width for better responsiveness */
  /*padding: 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #f9f9f9;
} */
`, "",{"version":3,"sources":["webpack://./src/MyComponents/Actions/ActivityList.css"],"names":[],"mappings":"AAAA;;qEAEqE;CACpE,uDAAuD;CACvD,gDAAgD;EAC/C,yDAAyD;CAC1D,uDAAuD;AACxD,KAAK;;AAEL;4EAC4E;EAC1E,+EAA+E;EAC/E,+DAA+D;EAC/D,sEAAsE;EACtE;;;;GAIC","sourcesContent":["/*.activity-row {\n  display: flex;\n  justify-content: space-between; /* Ensure space between the boxes */\n /* align-items: flex-start; /* Align items at the top */\n /* gap: 16px; /* Add spacing between the boxes */\n  /*flex-wrap: wrap; /* Allow wrapping for responsiveness */\n /* margin: 16px 0; /* Add some spacing around the row */\n/*} */\n\n/* .AP_ModuleProjectLesson {\n  /*flex: 1 1 calc(50% - 16px); /* Take 50% of the container minus the gap */\n  /*box-sizing: border-box; /* Include padding and borders in width calculation */\n  /*max-width: calc(50% - 16px); /* Prevent exceeding 50% width */\n  /*min-width: 350px; /* Set a minimum width for better responsiveness */\n  /*padding: 16px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background-color: #f9f9f9;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
